// @flow

import React from 'react';
import _ from 'lodash';
import LinkButton from 'client/components/button/linkButton';
import Translate from 'client/components/translate';

type Props = {
  healthGuideTranslations: Object,
  trackAction: Function,
};

const ctaButtonProps = {
  className: 'cta-button ghost-button',
};

function GuideFooter({ healthGuideTranslations, trackAction }: Props) {
  const doctor = _.get(healthGuideTranslations, 'guideFooterDoctor', {});
  const drugs = _.get(healthGuideTranslations, 'guideFooterDrugs', {});
  const spending = _.get(healthGuideTranslations, 'guideFooterSpending', {});
  const plan = _.get(healthGuideTranslations, 'guideFooterPlan', {});

  const itemSet = [doctor, drugs, spending, plan].map(item => ({
    divClassName: item.divClassName,
    imgClassName: item.imgClassName,
    textClassName: item.textClassName,
    alt: item.alt,
    src: item.src,
    text: item.text,
  }));

  return (
    <div className="guide-body-footer">
      <h3 className="guide-body-footer-header">With insurance through Stride:</h3>
      <div className="guide-body-footer-items">
        {itemSet.map(item => (
          <div className={`guide-body-child ${item.divClassName}`} key={item.src}>
            <img className={item.imgClassName} alt={item.alt} src={item.src} />
            <div className={`illustration-wording ${item.textClassName}`}>{item.text}</div>
          </div>
        ))}
      </div>
      <div className="guide-body-footer-cta">
        <LinkButton
          href="/shop/location"
          {...ctaButtonProps}
          onClick={() => trackAction('onboarding-funnel')}>
          <Translate path="healthGuide.cta" />
        </LinkButton>
      </div>
    </div>
  );
}

export default GuideFooter;
